
export const TrainingPlanDetails = {
    path: '/training_plan_details/:planId',
    name: 'training_plan_details',
    component: () => import('@/views/Training/TrainingPlan/TrainingPlanDetailsPage.vue'),
    children: [
        {
            path: '/training_plan_details/view/:id',
            name: 'training_plan_details.view',
            component: () => import('@/views/Training/TrainingRequest/Form/TrainingRequestForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/training_plan_details/add_to_catalog/:id',
            name: 'training_plan_details.add_to_catalog',
            component: () => import('@/views/Training/TrainingRequest/Form/AddToCatalog.vue'),
            children: [
                {
                    path: '/training_plan_details/add_to_catalog/catalogs/add',
                    name: 'training_plan_details.add_to_catalog.catalogs.add',
                    component: () => import('@/views/Training/Catalog/Form/CatalogForm.vue'),
                    props: {addAction: true}
                },
            ]
        },
        {
            path: '/training_plan_details/set_decision/:id/:module',
            name: 'training_plan_details.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
        },
        {
            path: '/training_plan_details/take_in_charge/:id/:module',
            name: 'training_plan_details.take_in_charge',
            component: () => import('@/views/Request/Components/TakeInCharge.vue'),
        },
        {
            path: '/training_plan_details/timelines/:id/:module',
            name: 'training_plan_details.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
        },
        {
            path: '/training_plan_details/documents/:id',
            name: 'training_plan_details.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "TRAINING_REQUEST"}
        },
    ],
}